import React, {useState} from 'react';
import {ICONS} from '../Constants/Icons';
import Modal from '../Component/UI/modals/Modal';

const transactionTypes = [
  {title: 'Sales Payout', value: 1},
  {title: 'Sales No Payout', value: 2},
  {title: 'Sales Payout Reversal', value: 3},
  {title: 'Sales No Payout Reversal', value: 4},
  {title: 'Seller Commission', value: 5},
  {title: 'Seller Commission Reversal', value: 6},
  {title: 'Seller Transfer', value: 7},
  {title: 'Seller Transfer Reversal', value: 8},
  {title: 'Seller Payout', value: 9},
  {title: 'Seller Subscription', value: 10},
  {title: 'Seller Payment Processing Fee', value: 11},
  {title: 'Seller Payment Processing Fee Reversal', value: 12},
  {title: 'Sub Total', value: 13},
  {title: 'Customer Commission', value: 14},
  {title: 'Tax', value: 15},
  {title: 'Shipping Charge', value: 16},
  {title: 'Refund', value: 17},
  {title: 'Special Fee', value: 18},
  {title: 'Coupon', value: 19},
  {title: 'Seller Protection Fee', value: 20},
];

const FilterContent = ({
  onCloseModal,
  selectedTransactionFilterType,
  setSelectedTransactionFilterType,
}) => {
  const [selectedTypes, setSelectedTypes] = useState(
    selectedTransactionFilterType,
  );
  const [isLoading, setIsLoading] = useState(false);

  const onCheckClick = type => {
    const isSelected = selectedTypes.includes(type.value);
    if (isSelected) {
      setSelectedTypes(selectedTypes.filter(t => t !== type.value));
    } else {
      setSelectedTypes([...selectedTypes, type.value]);
    }
  };

  const onApply = () => {
    // Here you can implement the filter logic
    setSelectedTransactionFilterType(selectedTypes);
    onCloseModal();
  };

  const onReset = () => {
    setSelectedTypes([]);
  };

  return (
    <div className="w-full relative">
      <p className="text-2xl font-medium text-primary w-full font-sans  px-4 py-2 border-b border-gray-200">
        Filter Transactions
      </p>
      <div className=" h-[calc(100vh-120px)] overflow-y-auto rounded-md flex flex-col gap-8  p-4">
        <div className="flex flex-col gap-2">
          {transactionTypes.map(type => (
            <div
              key={type.value}
              className="flex items-center justify-start gap-2 py-1.5">
              <input
                type="checkbox"
                className="border-AppNewGreen !outline-none ring-0 rounded-sm"
                checked={selectedTypes.includes(type.value)}
                onChange={() => onCheckClick(type)}
              />
              <p className="text-base font-normal text-AppTitleBlack font-sans items-center">
                {type.title}
              </p>
            </div>
          ))}
        </div>
      </div>
      <div className="flex items-center justify-between p-4">
        <button
          onClick={onReset}
          className="text-primary/90 hover:text-primary py-1.5">
          Reset filters
        </button>

        <div className="flex items-center gap-2">
          <button
            onClick={onCloseModal}
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50">
            Cancel
          </button>
          <button
            onClick={onApply}
            className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90">
            Apply
          </button>
        </div>
      </div>
      {isLoading && (
        <div className="h-full w-full bg-black/5 absolute inset-0 z-0">
          <div className="flex items-center justify-center h-full">
            Loading...
          </div>
        </div>
      )}
    </div>
  );
};

const TransactionFilter = ({
  selectedTransactionFilterType,
  setSelectedTransactionFilterType,
}) => {
  const [isOpenSidepan, setIsOpenSidepan] = useState(false);

  return (
    <div>
      <button
        className="   p-2 px-4 text-sm flex items-center gap-2 hover:bg-gray-100/90 mr-2 rounded"
        onClick={() => setIsOpenSidepan(true)}>
        {ICONS.adjustment_vertical} Filter
      </button>

      {isOpenSidepan && (
        <Modal onCloseModal={() => setIsOpenSidepan(false)}>
          <div className="max-w-[400px] absolute right-0 top-0 w-full h-full grid place-items-start bg-white backdrop-blur-sm z-50">
            <FilterContent
              onCloseModal={() => setIsOpenSidepan(false)}
              selectedTransactionFilterType={selectedTransactionFilterType}
              setSelectedTransactionFilterType={
                setSelectedTransactionFilterType
              }
            />
          </div>
        </Modal>
      )}
    </div>
  );
};

export default TransactionFilter;
